import { environments } from "../environments";

export function withSubPath(path: string): string {
  const subPath = environments.subPath?.replace(/\/$/, "") || "";
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (!subPath || subPath === "/") {
    return normalizedPath;
  }

  return `${subPath}${normalizedPath}`;
}